import { paperCreatorName, savedApprovalResult } from "../../../general/paper-identity";
import { DS } from "../../../theme-default";
import "whatwg-fetch";
import React from "react";
import Header from "../../header";
import "react-select/dist/react-select.css";
import { SkyLightStateless } from "react-skylight";
import { styles } from "../../menu/styles";
import RedirectIfNotLogged from "../../menu/redirect-if-not-logged";
import * as RequisitionTypes from "../../../general/paper-state";
import UserApprovalsTable from "./approveUsers/user-approvals-table";
import { currentStepRights, legacyRoute } from "./approveUsers/approval-rows";
import {
  INFO_VALUE_MAX_LENGTH,
  defaultInfoValue,
  recordedInfoLines,
} from "./approveUsers/info-lines";
import PaperStateChip from "./paper-state-chip";
import { canPrintPaper, PRINT_DISABLED_REASON } from "./paper-display";
import ArticlesTable from "./articles/articleTable";
import { CircularProgress, TextField } from "material-ui";
import { connect } from "react-redux";
import * as validator from "../../../general/validators/validator";
import * as RequisitionActions from "../../../services/paper-service";
import * as ErrorAction from "../../../redux/action/error-action";
import * as TimeUtils from "../../../general/time-utils";
import * as UserActionTracker from "../../../services/tracker/user-action-tracker";
import {
  ERROR_INFO_LINES_CHANGED,
  ERROR_INFO_LINES_MISSING,
  ERROR_REGISTRATION_NUMBER_MISSING,
  ERROR_STEP_ALREADY_HANDLED,
  ERROR_USER_CANNOT_APPROVE,
} from "../../../general/response-codes";

const STEP_ALREADY_HANDLED = "Pasul a fost deja aprobat sau respins de altcineva.";
const INFO_LINE_ERROR = "Completați rândul (cel mult " + INFO_VALUE_MAX_LENGTH + " de caractere)";
const INFO_LINES_CHANGED = "Rândurile de completat ale pasului s-au schimbat. Închideți și redeschideți referatul.";

// 409: a colleague acted on this step first; 400 "cannot approve": the step moved on meanwhile.
const isStepAlreadyHandled = (err) => {
  const response = err && err.response;
  const code = response && response.data && response.data.message;
  return (
    (response && response.status === 409 && code === ERROR_STEP_ALREADY_HANDLED) ||
    (response && response.status === 400 && code === ERROR_USER_CANNOT_APPROVE)
  );
};

class PaperEditModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: true,
      showApprovingProgress: false,
      approvals: [],
      articles: [],
      deletedArticlesIds: [],
      motivation: "",
      canUserApprove: false,
      state: null,
      stepAlreadyHandled: false,
      registrationNumber: "",
      // Info step: values typed so far, by line index (untouched lines keep their default).
      infoValues: {},
      error: {
        motivation: "",
        allQuantitiesZero: "",
      },
      shouldRefresh: false,
    };
  }

  closeModal = () => {
    this.setState({
      modalIsOpen: false,
    });
    this.props.hideError();
    this.props.onCancel(this.state.shouldRefresh);
  };

  componentWillUnmount() {
    this.props.hideError();
  }

  componentDidMount() {
    this.setState({
      articles: this.props.data.articles || [],
      approvals: this.props.data.approvals,
      modalIsOpen: true,
      motivation: this.props.data.motivation,
      canUserApprove: this.props.data.canUserApprove,
      state: this.props.data.state,
    });
  }

  componentDidUpdate(previousProps) {
    // The list reloaded the paper after another candidate handled the step.
    if (this.props.data !== previousProps.data && this.state.stepAlreadyHandled) {
      this.setState({
        articles: this.props.data.articles || [],
        approvals: this.props.data.approvals,
        motivation: this.props.data.motivation,
        canUserApprove: this.props.data.canUserApprove,
        state: this.props.data.state,
      });
    }
  }

  // Rights of the step waiting for approval, for its candidates (one person may hold
  // several steps, each with its own rights).
  stepRights = () =>
    currentStepRights({
      route: this.props.data.route || legacyRoute(this.props.data.flow ? this.props.data.flow.steps : []),
      approvals: this.state.approvals,
      paperState: this.state.state,
      userEmail: this.props.userEmail,
    });

  // Value of an info line: what was typed, else its default (the total for the "Sumă" line).
  infoValue = (index, label) =>
    this.state.infoValues[index] !== undefined
      ? this.state.infoValues[index]
      : defaultInfoValue(label, this.state.articles);

  // Like the server: line breaks and runs of spaces become one space.
  infoValuesToSend = () =>
    this.stepRights().infoLabels.map((label, index) =>
      String(this.infoValue(index, label)).replace(/\s+/g, " ").trim()
    );

  // After a refused save: the message goes under each line to fix, or under the last one when the
  // server refused lines that look fine here.
  infoLineError = (index, labels) => {
    if (!this.state.error.infoLines) {
      return undefined;
    }
    const values = labels.map((label, i) => String(this.infoValue(i, label)).replace(/\s+/g, " ").trim());
    const bad = (value) => value === "" || value.length > INFO_VALUE_MAX_LENGTH;
    if (bad(values[index]) || (!values.some(bad) && index === labels.length - 1)) {
      return this.state.error.infoLines;
    }
    return undefined;
  };

  onMotivationChange = (e) => {
    this.setState({
      motivation: e.target.value,
    });
  };

  onApprove = (paper, orderNumber) => {
    if (!this.state.articles || this.state.articles.length === 0) {
      this.props.showError("Nu puteti aproba un referat fara articole!");
      return;
    }
    let articles = this.state.articles;
    let numberOfZeroQuantity = 0;

    for (let e in articles) {
      if (
        validator.isEmpty(articles[e].quantity) ||
        articles[e].quantity === 0 ||
        articles[e].quantity === "0" ||
        articles[e].quantity < 0
      ) {
        numberOfZeroQuantity++;
      }

      if (!articles[e].error) {
        articles[e].error = {};
      }

      var noArticolBugetar = false;
      if (
        this.stepRights().canSetArticolBugetar &&
        this.state.canUserApprove &&
        validator.isEmpty(articles[e].articolBugetar)
      ) {
        articles[e].error.articolBugetar = "Articolul bugetar lipseste";
        noArticolBugetar = true;
      } else {
        articles[e].error.articolBugetar = null;
      }
      this.setState({ articles });

      if (noArticolBugetar) {
        return;
      }
    }
    if (numberOfZeroQuantity === articles.length) {
      const error = this.state.error;
      error.allQuantitiesZero = "E nevoie de cel putin un produs! ";
      this.setState({ error });
      return;
    }
    if (this.stepRights().canSetRegistrationNumber && validator.isEmpty((this.state.registrationNumber || "").trim())) {
      this.setState({ error: { ...this.state.error, registrationNumber: "Completați numărul de înregistrare" } });
      return;
    }
    const infoValues = this.infoValuesToSend();
    if (infoValues.some((value) => value === "" || value.length > INFO_VALUE_MAX_LENGTH)) {
      this.setState({ error: { ...this.state.error, infoLines: INFO_LINE_ERROR } });
      return;
    }

    this.approve(paper, true, orderNumber);
  };

  onReject = (paper, orderNumber) => {
    if (validator.isEmpty(this.state.motivation)) {
      this.setState({
        error: {
          motivation: "Lipseste motivarea respingerii",
        },
      });
      return;
    }
    this.approve(paper, false, orderNumber);
  };

  approve = (paper, approve, orderNumber) => {
    this.setState({
      showApprovingProgress: true,
    });
    const registrationNumber =
      approve && this.stepRights().canSetRegistrationNumber ? this.state.registrationNumber.trim() : undefined;
    const infoLabels = approve && this.stepRights().infoLabels.length > 0 ? this.stepRights().infoLabels : undefined;
    const infoValues = infoLabels ? this.infoValuesToSend() : undefined;
    RequisitionActions.approve(
      paper.id,
      approve,
      this.state.motivation,
      this.state.deletedArticlesIds,
      this.state.articles,
      orderNumber,
      registrationNumber,
      infoValues,
      infoLabels
    )
      .then((t) => {
        const result = savedApprovalResult(t);
        if (registrationNumber) {
          paper.registrationNumber = registrationNumber;
          paper.registrationDate = result.approval && result.approval.date;
        }
        const newApprovals = [...this.state.approvals, result.approval];
        // True when the same person also holds the next step of this paper.
        const canApproveNext = !!result.canUserApprove;
        paper.approvals = newApprovals;
        paper.state = result.paperState;
        this.setState({
          approvals: newApprovals,
          canUserApprove: canApproveNext,
          // The next step (same person) starts from its own defaults.
          infoValues: {},
          showApprovingProgress: false,
          state: result.paperState,
          shouldRefresh: true,
        });
        paper.canUserApprove = canApproveNext;
        this.props.onApproveFinished(paper);
        this.props.hideError();
        UserActionTracker.trackPaperApproval(approve, paper.id);
      })
      .catch((err) => {
        const code = err && err.response && err.response.data && err.response.data.message;
        if (code === ERROR_REGISTRATION_NUMBER_MISSING) {
          this.setState({
            showApprovingProgress: false,
            error: { ...this.state.error, registrationNumber: "Completați numărul de înregistrare (cel mult 64 de caractere)" },
          });
          return;
        }
        // The step's lines changed, or the step became an info step, since the paper was opened.
        if (code === ERROR_INFO_LINES_CHANGED || (code === ERROR_INFO_LINES_MISSING && !infoLabels)) {
          this.props.showError(INFO_LINES_CHANGED);
          this.setState({ showApprovingProgress: false });
          return;
        }
        if (code === ERROR_INFO_LINES_MISSING) {
          this.setState({ showApprovingProgress: false, error: { ...this.state.error, infoLines: INFO_LINE_ERROR } });
          return;
        }
        if (isStepAlreadyHandled(err)) {
          this.setState({
            showApprovingProgress: false,
            canUserApprove: false,
            stepAlreadyHandled: true,
            shouldRefresh: true,
          });
          if (this.props.onStepAlreadyHandled) {
            this.props.onStepAlreadyHandled(paper);
          }
          return;
        }
        this.props.showError("Aprobarea a esuat! Va rog reincercati!");
        this.setState({
          showApprovingProgress: false,
        });
      });
  };

  onPricePerUnitChanged = (e, index) => {
    let newPrice = e.target.value;
    let article = this.state.articles[index];
    article.pricePerUnit = newPrice;
    let newArticles = this.state.articles;
    newArticles[index] = article;
    this.setState({
      articles: newArticles,
    });
  };

  onQuantityChanged = (e, index) => {
    let newQuantity = e.target.value;
    let article = this.state.articles[index];
    article.quantity = newQuantity;
    let newArticles = this.state.articles;
    newArticles[index] = article;
    this.setState({
      articles: newArticles,
    });
  };

  onArticolBugetarChange = (e, index) => {
    let newValue = e.target.value;
    let article = this.state.articles[index];
    article.articolBugetar = newValue;
    let newArticles = this.state.articles;
    newArticles[index] = article;
    this.setState({
      articles: newArticles,
    });
  };

  onVatChanged = (e, index) => {
    let newQuantity = e.target.value;
    let article = this.state.articles[index];
    article.vat = newQuantity;
    let newArticles = this.state.articles;
    newArticles[index] = article;
    this.setState({
      articles: newArticles,
    });
  };

  onDeleteClicked = (index, article) => {
    let newArticles = this.state.articles;
    newArticles.splice(index, 1);
    this.setState({
      articles: newArticles,
      deletedArticlesIds: this.state.deletedArticlesIds.concat([article.id]),
    });
  };

  render() {
    let totalPriceNoVat = 0;
    let totalPriceWithVat = 0;
    this.state.articles.forEach((e) => {
      let priceAllNoVat = e.quantity * e.pricePerUnit;
      totalPriceWithVat += (priceAllNoVat * e.vat) / 100 + priceAllNoVat;
      totalPriceNoVat += e.quantity * e.pricePerUnit;
    });

    totalPriceNoVat = Math.round(totalPriceNoVat * 100) / 100;
    totalPriceWithVat = Math.round(totalPriceWithVat * 100) / 100;
    const rights = this.stepRights();
    const fillingInfo = this.state.canUserApprove && rights.infoLabels.length > 0;

    return (
      <div>
        <RedirectIfNotLogged />

        <SkyLightStateless
          isVisible={this.state.modalIsOpen}
          dialogStyles={styles.defaultDialogStyles}
          onCloseClicked={this.closeModal}
          onOverlayClicked={this.closeModal}
          title={<Header title={this.props.title} />}
        >
          <div id={"parent"} style={{ display: "block", overflow: "auto" }}>
            <div>
              <div className="ds-detail-grid">
                <div>
                  <div>
                    <strong>Cod: </strong>
                    <span>
                      {this.props.data.yearId +
                        "/" +
                        this.props.data.createdYear}
                    </span>
                  </div>
                  <div style={{ marginTop: "5px" }}>
                    <strong>Compartiment: </strong>
                    <span>{this.props.data.department.name}</span>
                  </div>
                  <div style={{ marginTop: "5px" }}>
                    <strong>Data crearii: </strong>
                    <span>
                      {TimeUtils.getSimpleFormat(this.props.data.createdDate)}
                    </span>
                  </div>
                  <div style={{ marginTop: "5px" }}>
                    <strong>Justificarea achizitiei: </strong>
                    <span style={{ wordWrap: "break-word" }}>
                      {this.props.data.justification}
                    </span>
                  </div>
                  {this.props.canDownload && (
                    <div style={{ marginTop: "5px" }}>
                      <strong>Descarca: </strong>

                      <button
                        className="ds-link-btn"
                        disabled={!canPrintPaper({ state: this.state.state }, this.props.companyId)}
                        title={canPrintPaper({ state: this.state.state }, this.props.companyId) ? undefined : PRINT_DISABLED_REASON}
                        onClick={() => this.props.onClickPrint(this.props.data)}
                      >
                        PRINT
                      </button>

                      {this.props.downloadingDoc && (
                        <CircularProgress
                          size={15}
                          style={{ marginLeft: "10px" }}
                        />
                      )}
                    </div>
                  )}
                </div>

                <div>
                  <div>
                    <strong>Categorie achizitie: </strong>
                    <span>{this.props.data.acquisitionCategory.name}</span>
                  </div>
                  <div style={{ marginTop: "5px" }}>
                    <strong>Sursa de finanatare: </strong>
                    <span>{this.props.data.financeSource.name}</span>
                  </div>
                  <div style={{ marginTop: "5px" }}>
                    <strong>Stare: </strong>
                    <PaperStateChip state={this.state.state} />
                  </div>

                  <div style={{ marginTop: "5px" }}>
                    <strong>Creat de: </strong>
                    <span>
                      {paperCreatorName(this.props.data)}
                    </span>
                  </div>

                  {this.props.data.registrationNumber && (
                    <div style={{ marginTop: "5px" }}>
                      <strong>Nr. înregistrare: </strong>
                      <span>
                        {this.props.data.registrationNumber}
                        {this.props.data.registrationDate &&
                          " din " + TimeUtils.getSimpleFormat(this.props.data.registrationDate)}
                      </span>
                    </div>
                  )}

                  {recordedInfoLines(this.state.approvals).map((filled) =>
                    filled.lines.map((line, index) => (
                      <div key={"info-" + filled.order + "-" + index} style={{ marginTop: "5px" }}>
                        <strong>{line.label}: </strong>
                        <span style={{ wordWrap: "break-word" }}>{line.value}</span>
                      </div>
                    ))
                  )}

                  {fillingInfo &&
                    rights.infoLabels.map((label, index) => (
                      <div key={"info-input-" + index} style={{ marginTop: "5px" }}>
                        <strong>{label}: </strong>
                        <TextField
                          id={"info-line-" + index}
                          value={this.infoValue(index, label)}
                          errorText={this.infoLineError(index, rights.infoLabels)}
                          onChange={(e) =>
                            this.setState({
                              infoValues: { ...this.state.infoValues, [index]: e.target.value },
                              error: { ...this.state.error, infoLines: "" },
                            })
                          }
                        />
                      </div>
                    ))}

                  {this.state.canUserApprove && rights.canSetRegistrationNumber && (
                    <div style={{ marginTop: "5px" }}>
                      <strong>Nr. înregistrare: </strong>
                      <TextField
                        hintText={"Numărul din registru"}
                        value={this.state.registrationNumber}
                        errorText={this.state.error.registrationNumber}
                        onChange={(e) =>
                          this.setState({
                            registrationNumber: e.target.value,
                            error: { ...this.state.error, registrationNumber: "" },
                          })
                        }
                      />
                    </div>
                  )}

                  <div style={{ marginTop: "5px" }}>
                    {this.state.canUserApprove && !fillingInfo ? (
                      <div>
                        <strong>Motivatie/rezolutie: </strong>
                        <TextField
                          hintText={"Motivati respingerea"}
                          value={this.state.motivation}
                          errorText={this.state.error.motivation}
                          onChange={this.onMotivationChange}
                        />
                      </div>
                    ) : RequisitionTypes.isRejected(this.state.state) ? (
                      <div className="ds-callout ds-callout--danger">
                        <i className="material-icons">report</i>
                        <div>
                          <strong>Motivul respingerii</strong>
                          <div>{this.state.motivation}</div>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>

            {
              <ArticlesTable
                articles={this.state.articles}
                yearId={this.props.data.yearId}
                createdYear={this.props.data.createdYear}
                canEdit={true}
                canEditPapers={rights.canEditPapers}
                canDeleteArticles={
                  this.props.companyId === 6 &&
                  rights.canEditPapers &&
                  this.state.canUserApprove &&
                  !this.state.showApprovingProgress
                }
                canSetArticolBugetar={rights.canSetArticolBugetar}
                canUserApprove={this.state.canUserApprove}
                onVatChanged={this.onVatChanged}
                onQuantityChanged={this.onQuantityChanged}
                onArticolBugetarChange={this.onArticolBugetarChange}
                onPricePerUnitChanged={this.onPricePerUnitChanged}
                onDeleteClicked={this.onDeleteClicked}
                onEditClicked={this.onEditClicked}
                onFileDownloadClick={this.onFileDownloadClick}
              />
            }

            {this.state.error.allQuantitiesZero && (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                  marginRight: 20,
                }}
              >
                <strong style={{ color: DS.error }}>
                  {this.state.error.allQuantitiesZero}
                </strong>
              </div>
            )}

            <div style={{ width: "100%", display: "flex" }}>
              <div style={{ margin: "0 auto" }}>
                {totalPriceNoVat > 0 && <strong>Pret total fara TVA</strong>}
              </div>

              <div style={{ margin: "0 auto" }}>
                {totalPriceWithVat > 0 && <strong>Pret total cu TVA</strong>}
              </div>
            </div>

            <div style={{ width: "100%", display: "flex" }}>
              <div style={{ margin: "0 auto" }}>
                {totalPriceNoVat > 0 && <span>{totalPriceNoVat} RON</span>}
              </div>

              <div style={{ margin: "0 auto" }}>
                {totalPriceWithVat > 0 && <span>{totalPriceWithVat} RON</span>}
              </div>
            </div>

            <div style={{ marginTop: "30px" }}>
              <strong>Utilizatori care trebuie sa aprobe referatul</strong>
            </div>

            {this.state.stepAlreadyHandled && (
              <div className="ds-callout" style={{ marginTop: "10px" }}>
                <i className="material-icons">info</i>
                <div>{STEP_ALREADY_HANDLED}</div>
              </div>
            )}

            <div>
              <UserApprovalsTable
                paper={this.props.data}
                paperId={this.props.data.id}
                canApprove={this.state.canUserApprove}
                steps={this.props.data.flow ? this.props.data.flow.steps : []}
                route={this.props.data.route}
                approvals={this.state.approvals}
                showApprovingProgress={this.state.showApprovingProgress}
                state={this.state.state}
                onApprove={this.onApprove}
                onReject={this.onReject}
              />
            </div>
          </div>
        </SkyLightStateless>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    userId: state.login.user.id,
    companyId: state.login.user.companyId,
    userEmail: state.login.user.email,
    userFirstName: state.login.user.firstName,
    userLastName: state.login.user.lastName,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    showError: (text) => dispatch(ErrorAction.showError(text)),
    hideError: () => dispatch(ErrorAction.hideError()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PaperEditModal);
